import { Badge, Button } from 'reactstrap';

interface Props {
    words: string[],
    selectedWords: string[],
    onChange: (selectedWords: string[]) => void,
}

export const WordCloud = (props: Props) => {

    const isStyleSelected = (style: string) => {
        return props.selectedWords.includes(style);
    }
    
    const toggleStyle = (style: string) => {
        if (!isStyleSelected(style)) {
          props.onChange(props.selectedWords.concat([style]));
        } else {
          props.onChange(props.selectedWords.filter(selectedWord => selectedWord !== style));
        }
    }
    
    const selectAll = () => {
        props.onChange(props.words);
    }
    
    const selectNone = () => {
        props.onChange([]);
    }
    
    const invertSelection = () => {
        props.onChange(props.words.filter(word => !props.selectedWords.includes(word)));
    }
    
    return (
        <>
            <Button color="link" onClick={() => selectAll()}>Select all</Button>
            &nbsp;
            <Button color="link" onClick={() => selectNone()}>Select none</Button>
            &nbsp;
            <Button color="link" onClick={() => invertSelection()}>Invert selection</Button>
            <br/>

        {
            props.words.map(word =>
              <span key={word} style={{cursor: "pointer"}}><Badge key={word} color={isStyleSelected(word) ? "primary" : "secondary"} pill onClick={() => toggleStyle(word)}>{word}</Badge>&nbsp;</span>
            )
        }
        </>
    );
}
  